import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import type { GranjaLoteConfig } from '../../services/granjaService';

interface LoteSelectorButtonsProps {
  lotes: GranjaLoteConfig[];
  selected?: string | null;
  onSelect: (codigo: string) => void;
  title?: string;
}

const LoteSelectorButtons: React.FC<LoteSelectorButtonsProps> = ({
  lotes,
  selected,
  onSelect,
  title = 'Lote',
}) => {
  const activos = (lotes ?? []).filter((l) => l.activo);
  return (
    <Box>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(90px, 1fr))',
          gap: 1,
        }}
      >
        {activos.map((lote) => {
          const isSelected = selected === lote.codigo;
          return (
            <Button
              key={lote.codigo}
              variant={isSelected ? 'contained' : 'outlined'}
              color="primary"
              onClick={() => onSelect(lote.codigo)}
              sx={{
                minHeight: 64,
                fontSize: '1.1rem',
                fontWeight: 700,
                borderRadius: 2,
              }}
            >
              {lote.codigo}
            </Button>
          );
        })}
      </Box>
      {activos.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          No hay lotes activos. Configuralos en Granja → Configuración.
        </Typography>
      ) : null}
    </Box>
  );
};

export default LoteSelectorButtons;
